export const groupConfig = {
  itemLabel: "Group",
  assignableItemLabel: "Users",
  assignableItemKey: "name",
  endpoints: {
    items: "/groups",
    assignableItems: "/users",
  },
  fields: [
    { key: "name", label: "Name*" },
    { key: "description", label: "Description*" },
    { key: "creationDate", label: "Creation Date" },
  ],
  actionButtons: [{ label: "Permissions" }, { label: "Import Permissions" }],
};

export const userConfig = {
  itemLabel: "User",
  assignableItemLabel: "Groups",
  assignableItemKey: "name",
  endpoints: {
    items: "/users",
    assignableItems: "/groups",
  },
  fields: [
    { key: "name", label: "User Name*" },
    { key: "password", label: "Password*" },
    { key: "email", label: "Email*" },
    { key: "status", label: "Status*" },
    { key: "firstName", label: "First Name" },
    { key: "lastName", label: "Last Name" },
    { key: "phone", label: "Phone" },
    { key: "mobile", label: "Mobile" },
    { key: "position", label: "Position" },
    { key: "title", label: "Title" },
    { key: "creationDate", label: "Creation Date" },
    { key: "resetPasswordRequired", label: "Reset Password" },
  ],
};
